const utils = {
  catalogTypes: [],
  deCopy (obj) {
    return JSON.parse(JSON.stringify(obj))
  },
    // 顺序交换
  exchange (type, index, arr) {
    let len = arr.length
    if ((type == -1 && !index) || (type == 1 && index == len - 1)) return
    let changeIndex = 0
    if (type == 1) {
      changeIndex = index + 1
    }
    if (type == -1) {
      changeIndex = index - 1
    }
    let tmp = arr[index]
    arr.splice(index, 1, arr[changeIndex])
    arr.splice(changeIndex, 1, tmp)
  },
  isEmpty (param) {
    if (!param && param !== 0 && param !== '') return true
    if (Array.prototype.isPrototypeOf(param) && param.length === 0) return true
    if (Object.prototype.isPrototypeOf(param) && Object.keys(param).length === 0) return true
    return false
  },
  getTypes (node, callback) {
    let obj = null
    if (!node) return
    if (node.sub_catalog) {
      obj = node.sub_catalog
    } else if (Array.isArray(node.catalog)) {
      obj = node
    }
    if (!obj || obj.catalog.length == 0) {
      callback()
      return
    }
    for (let i = 0, len = obj.catalog.length; i < len; i++) {
      this.catalogTypes.push(obj.catalog[i].catalog_type)
      this.getTypes(obj.catalog[i], callback)
    }
  },
  getQueryByName (url, name) {
    let reg = new RegExp('[?&]' + name + '=([^&#]+)')
    let query = url.match(reg)
    return query ? query[1] : null
  },
  // 兼容火狐拖起新开页 兼容谷歌拖起样式问题
  dragStartStyle(event) {
    event.dataTransfer.setData('a', '');
    event.target.style.opacity = '0.99';
    setTimeout(function () {
      event.target.style.opacity = '1';
    }, 0);
  },
  // 拖放公共方法
  dragOver(event) {
    event.preventDefault();
    event.stopPropagation();
  },
  // 禁止空节点拖拽
  nullDrag(event) {
    event.preventDefault();
  },
}

export default utils



// WEBPACK FOOTER //
// ./common/commonModule/magicCube/assets/js/utils.js